import styled, { css } from 'styled-components'
import { lighten } from 'polished'

export const Container = styled.div`
  margin: 5px 0 5px;
  padding: 0.6rem 0.55rem;
  display: flex;
  flex-direction: column;

  border-radius: 0.2857rem;
  ${({ type }) =>
    type === 'info' &&
    css`
      background-color: ${props => props.theme.info};
      span {
        font-weight: 400;
        color: ${props => lighten(0.9, props.theme.info)};
      }
    `}
  ${({ type }) =>
    type === 'warn' &&
    css`
      background-color: ${props => props.theme.warn};
      span {
        font-weight: 400;
        color: ${props => lighten(0.9, props.theme.warn)};
      }
    `}

    ${({ type }) =>
    type === 'success' &&
    css`
        background-color: ${props => props.theme.success};
        span {
          font-weight: 400;
          color: ${props => lighten(0.9, props.theme.success)};
        }
      `}

      ${({ type }) =>
    type === 'error' &&
    css`
          background-color: ${props => props.theme.error};
          span {
            font-weight: 400;
            color: ${props => lighten(0.9, props.theme.error)};
          }
        `}

    ${({ page }) => page === 'true' && css``}
`
